export default class MatchingTableRowModel {
  constructor () {
    this.caregiverId = 0
    this.type = ''
    this.name = ''
    this.phone = ''
    this.address = ''
    this.rating = 0
    this.cases = 0
    this.avgShifts = 0
    this.shifts = 0
    this.status = ''
    this.level = 0
    this.timestamp = ''
    this.customerRejected = false
    this.sentProfileAt = ''
    this.feedback = []
    this.reasonTitle = ''
    this.reasonDetail = ''
  }

  static fromJSON (json) {
    let tableRow = new MatchingTableRowModel()
    tableRow.caregiverId = json.id
    tableRow.type = json.type
    tableRow.name = json.name
    tableRow.phone = json.phone
    tableRow.address = json.address
    tableRow.rating = json.rating
    tableRow.cases = json.cases
    tableRow.avgShifts = json.avgShifts
    tableRow.shifts = json.shifts
    tableRow.status = json.status
    tableRow.level = json.level
    tableRow.timestamp = json.timestamp
    tableRow.customerRejected = json.customerRejected
    tableRow.sentProfileAt = json.sentProfileAt
    tableRow.feedback = json.feedback
    tableRow.reasonTitle = json.reasonTitle
    tableRow.reasonDetail = json.reasonDetail
    return tableRow
  }
}
